<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-notification-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.535 2.707l39.599 39.598a1 1 0 010 1.414l-1.415 1.414a1 1 0 01-1.414 0L2.707 5.536a1 1 0 010-1.415l1.414-1.414a1 1 0 011.414 0zM29 40a1 1 0 011 1v2a1 1 0 01-1 1H19a1 1 0 01-1-1v-2a1 1 0 011-1h10zM8.918 15.989l3.276 3.276A13.122 13.122 0 0012 21.522V33h13.929l4 4H5a1 1 0 01-1-1v-1.976a1 1 0 01.883-.993l.14-.007L8 33.095V21.516c0-1.938.324-3.8.918-5.527zM27 3a1 1 0 011 1v1.52c6.901 1.834 12 8.3 12 15.996V32.93l-4-4v-7.407C36 14.606 30.627 9 24 9c-2.251 0-4.358.647-6.158 1.772l-2.884-2.884A15.693 15.693 0 0120 5.52V4a1 1 0 011-1h6z"/></svg>
</template>
<script>

export default {
  name: 'IconNotificationOff',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
